import React from "react";
import { Stack } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import CustomChips from "../../../components/Content/CustomChip";
import BookPromos from "../../../components/Content/BookPromos";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  AMAZON_BOOK_LINK,
  EMAIL_LINK,
  EMAIL_ADDRESS,
  BOOK_TITLE,
  ANNOUNCEMENT_TEXT,
  EMAIL_CARD_TITLE,
  EMAIL_CARD_SUBTITLE,
  BOOK_IMAGE,
} from "./Publishers.constants";
import {
  RootBox,
  ContentBox,
  GridContainer,
  BookImage,
  BookCard,
  BookCardHeader,
  AnnouncementTypography,
  NorthEastIcon,
  BookTitleTypography,
  EmailCard,
  StyledEmailIcon,
  EmailCardTitleTypography,
  EmailAddressTypography,
  EmailCardSubtitleTypography,
  NorthEastIconSmall,
  BookImageContainer,
} from "./Publishers.styles";

const Publishers = () => {
  const handleBookClick = () => window.open(AMAZON_BOOK_LINK, "_blank");
  const handleEmailClick = () => window.open(EMAIL_LINK);

  return (
    <RootBox>
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <ContentBox>
        <CustomChips />

        <GridContainer container spacing={{ xs: 2, sm: 3 }}>
          <BookImageContainer>
            <BookImage src={BOOK_IMAGE} alt="Book Cover" />
          </BookImageContainer>
          <BookCard onClick={handleBookClick}>
            <BookCardHeader
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <AnnouncementTypography>
                {ANNOUNCEMENT_TEXT}
              </AnnouncementTypography>
              <NorthEastIcon />
            </BookCardHeader>

            <BookTitleTypography>{BOOK_TITLE}</BookTitleTypography>
          </BookCard>
        </GridContainer>

        <BookPromos />

        <EmailCard onClick={handleEmailClick}>
          <Stack direction="row" alignItems="flex-start" spacing={2}>
            <StyledEmailIcon />

            <Stack direction="column" alignItems="flex-start">
              <EmailCardTitleTypography>
                {EMAIL_CARD_TITLE}{" "}
                <EmailAddressTypography component="span">
                  {EMAIL_ADDRESS}
                </EmailAddressTypography>
              </EmailCardTitleTypography>
              <EmailCardSubtitleTypography>
                {EMAIL_CARD_SUBTITLE}
              </EmailCardSubtitleTypography>
            </Stack>
          </Stack>
          <NorthEastIconSmall />
        </EmailCard>
      </ContentBox>
    </RootBox>
  );
};

export default Publishers;
